import React from 'react';
import CrewHeader from './CrewHeader';
import CrewList from './CrewList';

const Crews = () => {
return <div className={`h-100`}>
    <CrewHeader />
    <CrewList />
</div>}

export default Crews;
